const RoutesMetaEnum = {
  TITLE_KEY: Symbol('titleKey'),
  BREADCRUMBS: Symbol('breadcrumbs'),
};

export default RoutesMetaEnum;
